var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.cookieModal)?_c('CookieModal',{on:{"closeModal":_vm.closeModal}}):_vm._e(),_c('mainBlock'),_c('aboutUsBlock',{attrs:{"id":"about-us-block"}}),_c('deliveryBlock',{attrs:{"id":"delivery"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }